import { useParams, useHistory } from 'react-router-dom';
import { getAppRoutes } from 'Pages/App/App.constants';

import { RolePermission, useCreateRole, useRoleDetail } from '../Roles.hooks';
import PermissionList, { RoleSubmitPayload } from './PermissionList';
import Spin from 'Components/Spin/Spin';
import { Notification } from 'Components';
import { useTranslation } from 'react-i18next';

function CloneRole() {
	const { roleId } = useParams<{ roleId: string }>();
	const history = useHistory();
	const { role, permissionList, loading } = useRoleDetail(roleId);
	const [createRole, { loading: cloning }] = useCreateRole();
	const { t } = useTranslation();
	
	const handleSubmit = async (values: RoleSubmitPayload) => {
		try {
			await createRole(values);
			history.push(getAppRoutes().ROLES);
		} catch (error) {
			Notification.error({
				description: t('errorCodes.genericErrorMessage')
			});
		}
	};

	if (loading || !role) return <Spin />;
	return (
		<PermissionList
			mode="clone"
			permissionList={permissionList}
			initialValues={{
				roleId: role.id,
				roleName: `${role.role} clone`,
				description: role.description,
				sourceRoleName: role.role,
				permissions: role.permissions?.map((permission: RolePermission) => permission.id) ?? []
			}}
			loading={cloning}
			onCancel={() => history.goBack()}
			onSubmit={handleSubmit}
		/>
	);
}

export default CloneRole;